export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Login Berhasil.'
      };
      this.$router.push({ path: 'perusahaan' });
    }
  },
  {
    name: 'APP_LOGIN_FAILED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Email and Password Salah'
      };
      this.$router.push({ path: 'login' });
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Logout Berhasil.'
      };
      this.$router.replace({ path: '/login' });
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.$router.push('/login');
      this.$message.error('Token has expired');
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  // {
  //   name: 'APP_TUTOR_REGISTRATION',
  //   callback: function (e) {
  //     this.$router.push({ path: '/tutor-registration-form' });
  //   }
  // },
  // {
  //   name: 'APP_TUTOR_REGISTRATION_COMPLETE',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'green',
  //       text: 'Registration Complete.'
  //     };
  //     this.$router.push({ path: '/tutor-registration-form-complete' });
  //   }
  // },
  // {
  //   name: 'APP_ADMIN_PROFILE',
  //   callback: function (e) {
  //     this.$router.replace({ path: '/admin-profile' });
  //   }
  // },
  // {
  //   name: 'APP_LAPORAN_PEMASUKKAN',
  //   callback: function (e) {
  //     this.$router.replace({ path: '/laporan/laporan-pemasukkan' });
  //   }
  // },
  // {
  //   name: 'APP_LAPORAN_PENGELUARAN',
  //   callback: function (e) {
  //     this.$router.replace({ path: '/laporan/laporan-pengeluaran' });
  //   }
  // },

  // DAFTAR ADMIN
  // {
  //   name: 'APP_CREATE_ADMIN',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'green',
  //       text: 'Admin Berhasil Dibuat'
  //     };
  //     this.$router.push({ path: 'daftar-admin' });
  //   }
  // },
  // {
  //   name: 'APP_CREATE_ADMIN_FAILED',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'red',
  //       text: 'Admin Tidak Berhasil Dibuat, Cek Kembali Koneksi Kamu'
  //     };
  //     this.$router.push({ path: 'daftar-admin' });
  //   }
  // },
  // {
  //   name: 'APP_UPDATE_ADMIN',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'green',
  //       text: 'Admin Berhasil Diperbaharui'
  //     };
  //     this.$router.push({ path: 'daftar-admin' });
  //   }
  // },
  // {
  //   name: 'APP_UPDATE_ADMIN_FAILED',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'red',
  //       text: 'Admin Tidak Berhasil Diperbaharui, Cek Kembali Koneksi Kamu'
  //     };
  //     this.$router.push({ path: 'daftar-admin' });
  //   }
  // },
  // {
  //   name: 'APP_DELETE_ADMIN',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'green',
  //       text: 'Admin Berhasil Dihapus'
  //     };
  //     this.$router.push({ path: 'daftar-admin' });
  //   }
  // },
  // {
  //   name: 'APP_DELETE_ADMIN_FAILED',
  //   callback: function (e) {
  //     this.snackbar = {
  //       show: true,
  //       color: 'red',
  //       text: 'Admin Tidak Berhasil Dihapus, Cek Kembali Koneksi Kamu'
  //     };
  //     this.$router.push({ path: 'daftar-admin' });
  //   }
  // },

  // Agroforestcape
  {
    name: 'APP_KONTRAK',
    callback: function (e) {
      this.$router.replace({ path: '/kontrak' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_KONTRAK',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-kontrak' });
    }
  },
  {
    name: 'APP_SIMPAN_TEMPLATE',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Template Berhasil Disimpan'
      };
    }
  },
  {
    name: 'APP_ULAS_KONTRAK',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Kontrak Berhasil Ditambahkan'
      };
      this.$router.replace({ path: '/ulas-kontrak' });
    }
  },
  {
    name: 'APP_KONTRAK_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Ulasan Kontrak Berhasil Disimpan'
      };
      this.$router.replace({ path: '/kontrak' });
    }
  },

  // Komoditas
  {
    name: 'APP_KOMODITAS',
    callback: function (e) {
      this.$router.replace({ path: '/komoditas' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_PESANAN_PENGIRIMAN_KOMODITAS',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-pesanan-pengiriman-komoditas' });
    }
  },
  {
    name: 'APP_ULAS_PESANAN_PENGIRIMAN',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Pesanan Pengiriman Berhasil Ditambahkan'
      };
      this.$router.replace({ path: '/ulas-pesanan-pengiriman' });
    }
  },
  {
    name: 'APP_KOMODITAS_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Ulasan Pengiriman Berhasil Disimpan'
      };
      this.$router.replace({ path: '/komoditas' });
    }
  },

  // Komoditas Pedagang Perantara
  {
    name: 'APP_KOMODITAS_PEDAGANG_PERANTARA',
    callback: function (e) {
      this.$router.replace({ path: '/komoditas-pedagang-perantara' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_PESANAN_PENGIRIMAN_PEDAGANG_PERANTARA',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-pesanan-pengiriman-pedagang-perantara' });
    }
  },
  {
    name: 'APP_ULAS_PESANAN_PENGIRIMAN_PEDAGANG_PERANTARA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Pesanan Pengiriman Berhasil Ditambahkan'
      };
      this.$router.replace({ path: '/ulas-pesanan-pengiriman-pedagang-perantara' });
    }
  },
  {
    name: 'APP_KOMODITAS_PEDAGANG_PERANTARA_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Ulasan Pengiriman Berhasil Disimpan'
      };
      this.$router.replace({ path: '/komoditas-pedagang-perantara' });
    }
  },

  // Komoditas Logistik
  {
    name: 'APP_KOMODITAS_LOGISTIK',
    callback: function (e) {
      this.$router.replace({ path: '/komoditas-logistik' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_PESANAN_PENGIRIMAN_LOGISTIK',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-pesanan-pengiriman-logistik' });
    }
  },
  {
    name: 'APP_ULAS_PESANAN_PENGIRIMAN_LOGISTIK',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Pesanan Pengiriman Berhasil Ditambahkan'
      };
      this.$router.replace({ path: '/ulas-pesanan-pengiriman-logistik' });
    }
  },
  {
    name: 'APP_KOMODITAS_LOGISTIK_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Ulasan Pengiriman Berhasil Disimpan'
      };
      this.$router.replace({ path: '/komoditas-logistik' });
    }
  },
  {
    name: 'APP_ALOKASI_DETAIL_LOGISTIK',
    callback: function (e) {
      this.$router.replace({ path: '/alokasi-detail-logistik' });
    }
  },

  // Gapoktan
  {
    name: 'APP_GAPOKTAN',
    callback: function (e) {
      this.$router.replace({ path: '/gapoktan' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_GAPOKTAN',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-gapoktan' });
    }
  },
  {
    name: 'APP_GAPOKTAN_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Gapoktan Berhasil Ditambahkan'
      };
      this.$router.replace({ path: '/gapoktan' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_GAPOKTAN_LAHAN',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-gapoktan-lahan' });
    }
  },
  {
    name: 'APP_GAPOKTAN_LAHAN_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Lahan Berhasil Ditambahkan'
      };
      this.$router.replace({ path: '/gapoktan' });
    }
  },
  
  // Pemerintah
  {
    name: 'APP_PEMERINTAH',
    callback: function (e) {
      this.$router.replace({ path: '/pemerintah' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_PEMERINTAH',
    callback: function (e) {
      this.$router.replace({
        path: '/tambahkan-pemerintah'
      });
    }
  },
  {
    name: 'APP_PEMERINTAH_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Instansi Pemerintah Berhasil Ditambahkan'
      };
      this.$router.replace({
        path: '/pemerintah'
      });
    }
  },

  // Pesanan Pengiriman
  {
    name: 'APP_PESANAN_PENGIRIMAN',
    callback: function (e) {
      this.$router.replace({ path: '/pesanan-pengiriman' });
    }
  },

  // Pergerakan Barang
  {
    name: 'APP_PERGERAKAN_BARANG',
    callback: function (e) {
      this.$router.replace({ path: '/pergerakan-barang' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_PERGERAKAN_BARANG',
    callback: function (e) {
      this.$router.replace({
        path: '/tambahkan-pergerakan-barang'
      });
    }
  },
  {
    name: 'APP_PERGERAKAN_BARANG_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Pergerakan Barang Berhasil Ditambahkan'
      };
      this.$router.replace({
        path: '/pergerakan-barang'
      });
    }
  },
  
  // Feedback
  {
    name: 'APP_FEEDBACK',
    callback: function (e) {
      this.$router.replace({ path: '/feedback' });
    }
  },
  {
    name: 'APP_TAMBAHKAN_FEEDBACK',
    callback: function (e) {
      this.$router.replace({ path: '/tambahkan-feedback' });
    }
  },
  {
    name: 'APP_FEEDBACK_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Feedback Berhasil Ditambahkan.'
      };
      this.$router.replace({ path: '/feedback' });
    }
  },

  // Konfirmasi Pesanan
  {
    name: 'APP_CONFIRMATION_ACCEPT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Pesanan Berhasil Dikonfirmasi.'
      };
    }
  },
  {
    name: 'APP_CONFIRMATION_REJECT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Pesanan Berhasil Ditolak.'
      };
    }
  },
];
